import { useEffect, useState } from "react";
import { ZoomMtg } from "@zoom/meetingsdk";
import { generateSignature } from "../../../src/middleware/signature";
import "../../zoom.css";
import { useLocation } from "react-router-dom";
import { decryptValue } from "../../utils/encryptionUtils";

const ZoomMeetingComponent = () => {
  const location = useLocation();
  const [meetingNumber, setMeetingNumber] = useState("");
  const [password, setPassWord] = useState("");
  const [userName, setUserName] = useState("");
  const [role, setRole] = useState("");

  const sdkKey = process.env.REACT_APP_ZOOM_SDK_KEY;
  const leaveUrl = process.env.REACT_APP_BASE_URL;

  useEffect(() => {
    ZoomMtg.preLoadWasm();
    ZoomMtg.prepareWebSDK();
    const queryParams = new URLSearchParams(location.search);
    setMeetingNumber(decryptValue(queryParams.get("meetingNumber")));
    setPassWord(decryptValue(queryParams.get("passWord")));
    setUserName(decryptValue(queryParams.get("userName")));
    setRole(decryptValue(queryParams.get("role")));
    const fetchSignature = async () => {
      try {
        const { signature } = await generateSignature(meetingNumber, role);
        startMeeting(signature);
      } catch (error) {
        console.error("Error generating signature:", error);
      }
    };
    const startMeeting = (signature) => {
      document.getElementById("zmmtg-root").style.display = "block";
      ZoomMtg.init({
        leaveUrl: leaveUrl,
        patchJsMedia: true,
        leaveOnPageUnload: true,
        success: () => {
          console.log("Zoom Meeting Initialized");
          ZoomMtg.join({
            signature: signature,
            sdkKey: sdkKey,
            meetingNumber: meetingNumber,
            passWord: password,
            userName: userName,
            userEmail: userName,
            success: (success) => {
              console.log("Join Meeting Success:", success);
            },
            error: (error) => {
              console.error("Join Meeting Error:", error);
            },
          });
        },
        error: (error) => {
          console.error("Zoom Init Error:", error);
        },
      });
    };
    if (meetingNumber && role) {
      fetchSignature();
    }
  }, [
    meetingNumber,
    role,
    password,
    userName,
    leaveUrl,
    location.search,
    sdkKey,
  ]);
};

export default ZoomMeetingComponent;
